module.exports = __webpack_public_path__ + "img/down-fj1.696b4201.jpg";